import { SourceType, finalizeDataSourcePickerOptions, isDefined } from '@aloft/toolkit-shared';

import { FieldPath, UseFormGetValues } from 'react-hook-form';

import { PropertyGridFieldName, PropertyGridForm } from '../../types.ts';
import { SourceOption } from './types.ts';

type UseSourceOptionsParams = {
  columns: PropertyGridForm['columns'];
  propertyId: string;
  fieldName: PropertyGridFieldName;
  toDisplayValue?: (value: string | undefined, propertyId: string) => string | undefined;
  getValues: UseFormGetValues<PropertyGridForm>;
  allowExplicitUnknown?: boolean;
};

export const useSourceOptions = ({
  columns,
  propertyId,
  fieldName,
  toDisplayValue,
  getValues,
  allowExplicitUnknown = true,
}: UseSourceOptionsParams): SourceOption[] => {
  const rows = columns
    .filter((column) => column?.propertyId === propertyId && column?.type !== 'property')
    .map(({ type: source }) => {
      const dataSourceColumnIndex = columns.findIndex(
        (column) => column?.propertyId === propertyId && column?.type === source,
      );

      if (dataSourceColumnIndex === -1) return undefined;

      const rawValue = getValues(
        `columns.${dataSourceColumnIndex}.propertyData.${fieldName}` as FieldPath<PropertyGridForm>,
      ) as unknown;

      if (!source) return undefined;

      return {
        value: toDisplayValue
          ? toDisplayValue(rawValue as string | undefined, propertyId)
          : (rawValue as string | undefined),
        rawValue,
        source: source as SourceType,
      };
    })
    .filter(isDefined);

  return finalizeDataSourcePickerOptions(rows, { allowExplicitUnknown });
};
